export default __webpack_public_path__ + "static/gba_ep1_compressed-981b520fb4116eb85ead803b00d015eb.mp4";